import { defineStore } from 'pinia'
import type { IDiscussionCategory } from '~/components/widget/discussions'

export const useDiscussionsCategoryStore = defineStore('discussions-categories-list', {
  state: () => ({
    list: [] as IDiscussionCategory[]
  })
})
